/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerTrackNextFilled = createReactComponent("filled", "player-track-next-filled", "IconPlayerTrackNextFilled", [["path", { "d": "M2 5v14c0 .86 1.012 1.318 1.659 .753l8 -7a1 1 0 0 0 0 -1.506l-8 -7c-.647 -.565 -1.659 -.106 -1.659 .753z", "key": "svg-0" }], ["path", { "d": "M13 5v14c0 .86 1.012 1.318 1.659 .753l8 -7a1 1 0 0 0 0 -1.506l-8 -7c-.647 -.565 -1.659 -.106 -1.659 .753z", "key": "svg-1" }]]);

export { IconPlayerTrackNextFilled as default };
//# sourceMappingURL=IconPlayerTrackNextFilled.mjs.map
